// extracted by mini-css-extract-plugin
export default {"header":"header__header___[chunkhash-base64-5]"};